import React, { useState } from 'react';
import { useDraggable } from '../hooks/useDraggable';

const AfasArticlePiP = ({ articles, onClose }) => {
  const [search, setSearch] = useState('');

  // Start positioned in the bottom right corner
  const { position, handlers: dragHandlers } = useDraggable(() => {
    if (typeof window !== 'undefined') {
      return {
        x: window.innerWidth - 340, // 320px width + 20px padding
        y: window.innerHeight - (window.innerHeight * 0.6) - 40 // 60vh height + 40px padding
      };
    }
    return { x: 20, y: 20 };
  });

  const filtered = articles.filter(a =>
    a.ItemCode.toLowerCase().includes(search.toLowerCase()) ||
    (a.ItemDescription && a.ItemDescription.toLowerCase().includes(search.toLowerCase())) ||
    (a.ArticleGroupCode && a.ArticleGroupCode.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div
      className="fixed w-80 bg-white rounded-lg shadow-2xl border border-gray-300 flex flex-col z-[100] overflow-hidden"
      style={{
        height: '60vh',
        left: position.x + 'px',
        top: position.y + 'px',
        margin: 0
      }}
    >
      <div
        className="bg-secondary text-white p-3 flex justify-between items-center cursor-move select-none"
        {...dragHandlers}
      >
        <h3 className="font-bold text-sm flex items-center gap-2 pointer-events-none">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
          </svg>
          AFAS Reference
        </h3>
        <button onClick={onClose} className="hover:text-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 pointer-events-none" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
      <div className="p-2 border-b bg-gray-50">
        <input
          type="text"
          placeholder="Search code or description..."
          className="w-full border rounded p-2 text-sm focus:ring-2 focus:ring-primary outline-none"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <div className="overflow-y-auto flex-1 p-2">
        {filtered.map(a => (
          <div key={a.id} className="p-2 border-b border-gray-100 hover:bg-fuchsia-50 rounded text-sm transition-colors">
            <div className="flex justify-between items-start">
              <div className="font-mono font-bold text-primary">{a.ItemCode}</div>
              {a.ArticleGroupCode && (
                <div className="text-[10px] font-mono bg-indigo-50 text-indigo-600 px-1.5 py-0.5 rounded border border-indigo-200 whitespace-nowrap" title="Article Group Code">
                  {a.ArticleGroupCode}
                </div>
              )}
            </div>
            <div className="text-gray-600 text-xs mt-1">{a.ItemDescription || <span className="italic text-gray-400">No description</span>}</div>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-center text-gray-500 p-4 text-sm">No matches found</div>}
      </div>
    </div>
  );
};

export default AfasArticlePiP;
